import { create } from 'zustand'
import type { TagValueUpdate, WsStatus } from '@/types/realtime'

interface RealtimeState {
  /** Latest value per subscribed tag. New Map reference on each update so
   *  selectors relying on identity re-render correctly. */
  tagValues: Map<string, TagValueUpdate>
  wsStatus: WsStatus
  subscribedTagIds: Set<string>

  setTagValue: (tagId: string, update: TagValueUpdate) => void
  setWsStatus: (status: WsStatus) => void
  addSubscription: (tagId: string) => void
  removeSubscription: (tagId: string) => void
  clearAll: () => void
}

export const useRealtimeStore = create<RealtimeState>((set) => ({
  tagValues: new Map(),
  wsStatus: 'disconnected',
  subscribedTagIds: new Set(),

  setTagValue: (tagId, update) =>
    set((state) => {
      const next = new Map(state.tagValues)
      next.set(tagId, update)
      return { tagValues: next }
    }),

  setWsStatus: (wsStatus) => set({ wsStatus }),

  addSubscription: (tagId) =>
    set((state) => {
      const next = new Set(state.subscribedTagIds)
      next.add(tagId)
      return { subscribedTagIds: next }
    }),

  removeSubscription: (tagId) =>
    set((state) => {
      const next = new Set(state.subscribedTagIds)
      next.delete(tagId)
      return { subscribedTagIds: next }
    }),

  clearAll: () =>
    set({ tagValues: new Map(), subscribedTagIds: new Set(), wsStatus: 'disconnected' }),
}))
